<div class="grid">
    <!-- AcceptUI binds at page load; must stay in DOM (not inside p-dialog). Visible Pay triggers this. -->
    <button
        #adminAcceptUiTrigger
        type="button"
        class="AcceptUI"
        style="position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0"
        [attr.data-apiLoginID]="acceptUiApiLoginId"
        [attr.data-clientKey]="acceptUiClientKey"
        data-acceptUIFormBtnTxt="Submit"
        data-acceptUIFormHeaderTxt="Payment Information"
        data-responseHandler="adminLicensePaymentResponseHandler"
        data-billingAddressOptions='{"show":true,"required":false}'
        aria-hidden="true"
        tabindex="-1">
    </button>

    <div class="col-12 mt-2">
        <p-card header="Administrator Licenses" styleClass="p-card-shadow mb-3">
            @if (loadingAdminInfo) {
                <p class="text-600 m-0">Loading administrator license information...</p>
            } @else {
                <div class="grid admin-license-summary">
                    <div class="col-12 md:col-4">
                        <div class="text-600 text-sm mb-1">Licensed administrators</div>
                        <div class="text-3xl font-semibold text-900">
                            {{ licensedAdminCount }}
                        </div>
                    </div>
                    <div class="col-12 md:col-4">
                        <div class="text-600 text-sm mb-1">Assigned administrators</div>
                        <div class="text-3xl font-semibold text-900">{{ assignedAdminCount }}</div>
                    </div>
                    <div class="col-12 md:col-4">
                        <div class="text-600 text-sm mb-1">Available slots</div>
                        <div class="text-3xl font-semibold text-900">{{ availableAdminSlots }}</div>
                    </div>
                </div>

                <!-- <div class="grid admin-license-summary mt-3">
                    <div class="col-12 md:col-4">
                        <div class="text-600 text-sm mb-1">Certified Advisors</div>
                        <div class="text-3xl font-semibold text-900">
                            {{ advisorAdminCount }}
                        </div>
                    </div>
                    <div class="col-12 md:col-4">
                        <div class="text-600 text-sm mb-1">Assigned Certified Advisors</div>
                        <div class="text-3xl font-semibold text-900">
                            {{ assignedAdvisorAdminCount }}
                        </div>
                    </div>
                </div> -->

                <div class="surface-100 border-round p-3 mt-3">
                    <div class="text-900 font-medium mb-2">Modify administrator licenses</div>
                    @if (companyInfoLoadFailed) {
                        <p-message
                            severity="error"
                            [text]="companyInfoUnavailableMessage"
                            styleClass="mb-3 w-full">
                        </p-message>
                    }
                    @if (showCloudLoginOption) {
                        <p class="text-600 mt-0 mb-3 text-sm">                       
                            Adjust the number of administrator licenses for your account. <br />
                            RightWorks Access requires an eFAACT Administrator license.  <br />
                            To add RightWorks Access, check the "RightWorks Access" checkbox and enter an email address for the account when purchasing the Additional Administrator license. <br />
                            To remove RightWorks Access, contact the <a href="https://efaact.freshdesk.com/support/login" target="_blank" rel="noopener noreferrer">eFAACT Helpdesk</a> to submit a removal request.
                        </p>
                    } @else { 
                        <p class="text-600 mt-0 mb-3 text-sm">                       
                            Adjust the number of administrator licenses for your account.
                        </p>
                    }
                    
                    <div class="flex flex-wrap align-items-center gap-3">
                        <div class="p-inputgroup admin-license-stepper" style="width: auto;">
                            <button
                                type="button"
                                pButton
                                pRipple
                                icon="pi pi-minus"
                                severity="secondary"
                                [disabled]="!canDecrementTargetAdminCount || !canModifyAdminLicenses"
                                (click)="decrementTargetAdminCount()">
                            </button>
                            <input
                                type="text"
                                pInputText
                                class="text-center"
                                style="width: 4rem;"
                                [readonly]="true"
                                [ngModel]="targetLicensedAdminCount" />
                            <button
                                type="button"
                                pButton
                                pRipple
                                icon="pi pi-plus"
                                severity="secondary"
                                [disabled]="!canModifyAdminLicenses"
                                (click)="incrementTargetAdminCount()">
                            </button>
                        </div>
                        <button
                            pButton
                            pRipple
                            type="button"
                            label="Apply change"
                            severity="primary"
                            [disabled]="licenseChangeDelta === 0 || !canModifyAdminLicenses"
                            (click)="applyLicenseChangePreview()">
                        </button>
                        <button
                            pButton
                            pRipple
                            type="button"
                            label="Reset"
                            severity="secondary"
                            [disabled]="licenseChangeDelta === 0 || !canModifyAdminLicenses"
                            (click)="resetTargetLicensedAdminCount()">
                        </button>
                    </div>
                    @if (licenseChangeSummary) {
                        <p-message severity="info" [text]="licenseChangeSummary" styleClass="mt-3 w-full"></p-message>
                    }
                    @if (adminLicensePreviewMessage) {
                        <p-message severity="success" [text]="adminLicensePreviewMessage" styleClass="mt-3 w-full"></p-message>
                    }
                </div>
            }
        </p-card>
    </div>

    @if (showAdminLicenseConfirmDialog) {
    <p-dialog
        [header]="adminLicenseDialogHeader"
        [visible]="true"
        [modal]="true"
        [closable]="false"
        [draggable]="false"
        [style]="{ width: 'min(90vw, 32rem)' }"
        (onHide)="onAdminLicenseConfirmDialogHide()">
        <div class="admin-license-confirm-dialog">
            @if (adminLicenseDialogMode === 'add') {
                @if (needsAdminLicensePaymentSetup) {
                    <p class="text-600 mt-0">
                        Your card will be charged today for the first month. 
                        Recurring subscriptions begin one month from today and bill on that same day each month.
                    </p>
                } @else {
                    <p class="text-600 mt-0">
                        Review the additional administrator licenses below before creating the subscriptions.
                    </p>
                }
            } @else {
                <p class="text-600 mt-0">
                    This will cancel an existing Authorize.Net subscription for the administrator license(s) below.
                </p>
            }           
            <div class="surface-100 border-round p-3 mb-3">
                <div class="flex justify-content-between mb-2">
                    <span class="font-medium text-900">Product</span>
                    <span>{{ additionalAdminProductName }}</span>
                </div>
                <div class="flex justify-content-between mb-2">
                    <span class="font-medium text-900">Price</span>
                    <span>${{ additionalAdminUnitPrice | number: '1.2-2' }} / month</span>
                </div>
                <div class="flex justify-content-between mb-2">
                    <span class="font-medium text-900">Quantity</span>
                    <span>{{ adminLicenseDialogQuantity }}</span>
                </div>
                <div class="flex justify-content-between">
                    <span class="font-medium text-900">Monthly total</span>
                    <span>${{ adminLicenseDialogTotal | number: '1.2-2' }}</span>
                </div>
            </div>
            @if (showCloudLoginOption && cloudLoginChecked && adminLicenseDialogMode === 'add') {
                <div class="surface-100 border-round p-3 mb-3">
                    <div class="flex justify-content-between mb-2">
                        <span class="font-medium text-900">Product</span>
                        <span>{{ rightworksAccessProductName }}</span>
                    </div>
                    <div class="flex justify-content-between mb-2">
                        <span class="font-medium text-900">Price</span>
                        <span>${{ rightworksAccessUnitPrice | number: '1.2-2' }} / month</span>
                    </div>
                    <div class="flex justify-content-between mb-2">
                        <span class="font-medium text-900">Quantity</span>
                        <span>{{ rightworksAccessDialogQuantity }}</span>
                    </div>
                    <div class="flex justify-content-between">
                        <span class="font-medium text-900">Monthly total</span>
                        <span>${{ rightworksAccessDialogTotal | number: '1.2-2' }}</span>
                    </div>
                </div>
            }
            @if (requiresCompanyEmailInput) {
                <div class="mb-3">
                    <p-floatlabel variant="on" class="w-full">
                        <input
                            pInputText
                            id="companyEmailAddr"
                            type="email"
                            class="w-full"
                            [(ngModel)]="companyEmailAddrInput"
                            autocomplete="email"
                            required />
                        <label for="companyEmailAddr">Email address</label>
                    </p-floatlabel>
                </div>
            }
            @if (showCloudLoginOption && adminLicenseDialogMode === 'add') {
                <div class="mb-3">
                    <div class="flex align-items-center gap-2 mb-2">
                        <p-checkbox
                            inputId="cloudLoginCheckbox"
                            [(ngModel)]="cloudLoginChecked"
                            [binary]="true"
                            (ngModelChange)="onCloudLoginCheckedChange($event)">
                        </p-checkbox>
                        <label for="cloudLoginCheckbox" class="cursor-pointer">RightWorks Access</label>
                    </div>
                    @if (cloudLoginChecked) {
                        <p-floatlabel variant="on" class="w-full">
                            <input
                                pInputText
                                id="emailForCloudLogin"
                                type="email"
                                class="w-full"
                                [(ngModel)]="emailForCloudLogin"
                                autocomplete="email" />
                            <label for="emailForCloudLogin">Email for RightWorks Access</label>
                        </p-floatlabel>
                    }
                </div>
            }
            @if (adminLicenseDialogMode === 'add') {
                @if (needsAdminLicensePaymentSetup) {
                    <p-message
                        severity="info"
                        styleClass="w-full mb-3"
                        [text]="adminLicensePaymentSetupInfoText">
                    </p-message>
                } @else {
                    <p-message
                        severity="info"
                        styleClass="w-full mb-3"
                        [text]="paymentMethodOnFileMessageText">
                    </p-message>
                }
            }           
            
            @if (adminLicenseDialogMode === 'add') {
                @if (needsAdminLicensePaymentSetup) {
                    <p-message
                        severity="info"
                        styleClass="w-full mb-3"
                        text="Each additional administrator license is created as its own standalone subscription after payment is accepted.">
                    </p-message>
                } @else {
                    <p-message
                        severity="info"
                        styleClass="w-full mb-3"
                        text="Each additional administrator license is created as its own standalone subscription.">
                    </p-message>
                }
            } @else {
                <p-message
                    severity="warn"
                    styleClass="w-full mb-3"
                    text="Canceling will stop billing for the selected administrator subscription(s). This action cannot be undone from this page.">
                </p-message>
            }           
            @if (adminLicenseConfirmError) {
                <p-message
                    severity="error"
                    [text]="adminLicenseConfirmError"
                    styleClass="w-full mb-3">
                </p-message>
            }
            @if (adminLicenseConfirmLoading && adminLicenseDialogMode === 'add' && needsAdminLicensePaymentSetup) {
                <p class="text-600 mt-0 mb-0">Processing payment and creating subscriptions...</p>
            }
        </div>

        <ng-template pTemplate="footer">
            @if (adminLicenseDialogMode === 'add') {
                <button
                    pButton
                    type="button"
                    label="Cancel"
                    severity="secondary"
                    [disabled]="adminLicenseConfirmLoading"
                    (click)="cancelAdminLicenseChange()">
                </button>
                @if (needsAdminLicensePaymentSetup) {
                    <button
                        pButton
                        type="button"
                        severity="primary"
                        [disabled]="adminLicenseConfirmLoading"
                        (click)="openAdminLicensePayment()">
                        Pay ${{ adminLicenseDialogCombinedTotal | number: '1.2-2' }}
                    </button>
                } @else {
                    <button
                        pButton
                        type="button"
                        label="Confirm"
                        severity="primary"
                        [loading]="adminLicenseConfirmLoading"
                        (click)="confirmAdminLicenseChange()">
                    </button>
                }
            } @else {
                <button
                    pButton
                    type="button"
                    label="Cancel subscription"
                    severity="danger"
                    [loading]="adminLicenseConfirmLoading"
                    (click)="startAdminLicenseRemoval()">
                </button>
                <button
                    pButton
                    type="button"
                    label="Cancel"
                    severity="secondary"
                    [disabled]="adminLicenseConfirmLoading"
                    (click)="cancelAdminLicenseChange()">
                </button>
            }
        </ng-template>
    </p-dialog>
    }

    @if (showAdminRemovalHelpdeskDialog) {
    <p-dialog
        header="Administrator Removal"
        [visible]="true"
        [modal]="true"
        [closable]="false"
        [draggable]="false"
        [style]="{ width: 'min(90vw, 28rem)' }">
        <p class="text-600 mt-0 mb-0">{{ adminRemovalHelpdeskMessage }}</p>
        <ng-template pTemplate="footer">
            <button
                pButton
                type="button"
                label="OK"
                severity="primary"
                (click)="dismissAdminRemovalHelpdeskDialog()">
            </button>
        </ng-template>
    </p-dialog>
    }

    @if (showAdminLicenseTypeChoice) {
    <p-dialog
        header="Annual or monthly subscription?"
        [visible]="true"
        [modal]="true"
        [closable]="false"
        [draggable]="false"
        [style]="{ width: 'min(90vw, 30rem)' }">
        <p class="text-600 mt-0 mb-2">
            You have both annual and monthly administrator subscriptions.
            Which type would you like to cancel?
        </p>
        <p class="text-600 mt-0 mb-0 text-sm">
            Annual licenses: {{ adminAnnualSubscriptionCount }} &nbsp;&middot;&nbsp;
            Monthly licenses: {{ adminMonthlySubscriptionCount }}
        </p>
        <ng-template pTemplate="footer">
            <button
                pButton
                type="button"
                label="Cancel"
                severity="secondary"
                (click)="dismissAdminLicenseTypeChoice()">
            </button>
            <button
                pButton
                type="button"
                label="Monthly"
                severity="primary"
                (click)="selectAdminLicenseRemovalType('M')">
            </button>
            <button
                pButton
                type="button"
                label="Annual"
                severity="primary"
                (click)="selectAdminLicenseRemovalType('A')">
            </button>
        </ng-template>
    </p-dialog>
    }

    @if (showAdminLicenseRemovalConfirm) {
    <p-dialog
        header="Are you sure?"
        [visible]="true"
        [modal]="true"
        [closable]="false"
        [draggable]="false"
        [style]="{ width: 'min(90vw, 26rem)' }">
        <p class="text-600 mt-0 mb-0">
            Are you sure you want to cancel
            {{ adminLicenseDialogQuantity }} administrator
            subscription{{ adminLicenseDialogQuantity === 1 ? '' : 's' }}?
        </p>
        @if (adminLicenseRemovalWillMix) {
            <p-message
                severity="warn"
                [text]="adminLicenseRemovalMixMessage"
                styleClass="w-full mt-3">
            </p-message>
        }
        <ng-template pTemplate="footer">
            <button
                pButton
                type="button"
                label="No, keep subscription"
                severity="secondary"
                [disabled]="adminLicenseConfirmLoading"
                (click)="dismissAdminLicenseRemovalConfirmation()">
            </button>
            <button
                pButton
                type="button"
                label="Yes, cancel subscription"
                severity="danger"
                [loading]="adminLicenseConfirmLoading"
                (click)="confirmAdminLicenseRemovalConfirmed()">
            </button>
        </ng-template>
    </p-dialog>
    }

    <!-- <div class="col" *ngIf="this.layout == 'list'">
        <p-card header="eFAACT Store" [style]="{height: '100%'}" subheader="Available products" styleClass="p-card-shadow">
            <div class="col-12" *ngFor="let product of products">
                <div class="flex flex-column xl:flex-row xl:align-items-start p-4 gap-4">
                    <img class="w-9 sm:w-16rem xl:w-10rem shadow-2 block xl:block mx-auto border-round" [src]="product.image" [alt]="product.name" />
                    <div class="flex flex-column sm:flex-row justify-content-between align-items-center xl:align-items-start flex-1 gap-4">
                        <div class="flex flex-column align-items-center sm:align-items-start gap-3">
                            <div class="text-2xl font-bold text-900">{{ product.name }}</div>
                            <div class="flex align-items-center gap-3">
                                <span class="flex align-items-center gap-2">
                                    <i class="pi pi-tag"></i>
                                    <span class="font-semibold">{{ product.category }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="flex sm:flex-column align-items-center sm:align-items-end gap-3 sm:gap-2">
                            <span class="text-2xl font-semibold">{{ '$' + product.price }}</span>
                            <button class="p-button-secondary" pButton type="button" icon="pi pi-shopping-cart" label="Add" (click)="onAddToCartClicked(product)"></button>
                        </div>
                    </div>
                </div>
            </div>
        </p-card>
    </div> -->
    
    <!-- <p-card class="xl:col-9 lg:col-6 md:col-6 sm:col-6" *ngIf="this.layout == 'grid'" header="eFAACT Store" [style]="{height: '100%'}" subheader="Available products" styleClass="p-card-shadow">
        <div>
            <div class="grid">
                <div class="xl:col-3 lg:col-6 md:col-12 sm:col-12 p-4 border-1 surface-border surface-card border-round" *ngFor="let product of products">
                    <div class="flex flex-wrap align-items-center justify-content-between gap-2">
                        <span class="flex align-items-center gap-2">
                            <i class="pi pi-tag"></i>
                            <span class="font-semibold">{{ product.category }}</span>
                        </span>
                    </div>
                    <div class="flex flex-column align-items-center gap-3 py-5">
                        <img class="w-9 shadow-2 border-round" [src]="product.image" [alt]="product.name" />
                        <div class="text-2xl font-bold">{{ product.name }}</div>
                    </div>
                    <div class="flex align-items-center justify-content-between">
                        <span class="text-2xl font-semibold">{{ '$' + product.price }}</span>
                        <button class="p-button-secondary" pButton type="button" icon="pi pi-shopping-cart" label="Add" (click)="onAddToCartClicked(product)"></button>
                    </div>
                </div>
            </div>
        </div>
    </p-card> -->
    
    <div class="xl:col-3 lg:col-6 md:col-6 sm:col-6" *ngIf="this.selectedProducts.length > 0">
        <p-card header="Checkout" [style]="{height: '100%'}" subheader="Cart" styleClass="p-card-shadow">
            <p-message *ngIf="transactionResponse != '/efaactstore'" severity="success" [text]="transactionResponse" styleClass="mr-2"></p-message>
            <div *ngFor="let product of selectedProducts" class="col-12 py-1 px-1 bg-bluegray-50 border-round" [hidden]="!this.showCart">
                <div class="flex flex-column xl:flex-row xl:align-items-start p-4 gap-4">
                    <img class="w-6 sm:w-12rem xl:w-8rem shadow-2 block xl:block mx-auto border-round" [src]="product.image" [alt]="product.name" />
                    <div class="flex flex-column sm:flex-row justify-content-between align-items-center xl:align-items-start flex-1 gap-4">
                        <div class="flex flex-column align-items-center sm:align-items-start gap-3">
                            <div class="text-base font-bold text-900">{{ product.name }}</div>
                            <div class="flex align-items-center gap-3">
                                <span class="flex align-items-center gap-2">
                                    <i class="pi pi-tag"></i>
                                    <span class="font-semibold text-sm">{{ product.category }}</span>
                                </span>
                            </div>
                            <div>
                                <div class="p-inputgroup">
                                    <button type="button" pButton pRipple style="width: 2em; height: 2em;" icon="pi pi-minus" styleClass="p-button-success" (click)="subtractQuantity(product)"></button>
                                    <input type="text" style="width: 2.5em; height: 2em; font-size: 14px;" pInputText placeholder="Quantity" [(ngModel)]="product.quantity"/>
                                    <button type="button" pButton pRipple style="width: 2em; height: 2em;" icon="pi pi-plus" styleClass="p-button-danger" (click)="addQuantity(product)"></button>
                                </div>
                            </div>
                        </div>
                        <div class="flex sm:flex-column align-items-center sm:align-items-end ">
                            <span class="text-base font-semibold">{{ '$' + product.price }}</span>
                        </div>
                        <div class="col-1">
                            <button style="width: 2em; height: 2em;" class="p-button-danger p-button-rounded p-button-outlined" pButton type="button" icon="pi pi-minus" (click)="removeFromCartClicked(product)"></button>
                        </div>
                    </div>
                </div>
            </div>
    
            <div class="col-12 flex-row align-items-center justify-content-center" [hidden]="!this.showCart">               
                <form id="paymentForm" method="POST" [action]="this.uri">
                    <input type="hidden" name="dataValue" id="dataValue" />
                    <input type="hidden" name="dataDescriptor" id="dataDescriptor" />
    
                    <input *ngFor="let product of selectedProducts" type="hidden" name="productids[]" id="productid" [value]="product.id" />
                    <input *ngFor="let product of selectedProducts" type="hidden" name="productnames[]" id="productname" [value]="product.name" />
                    <input *ngFor="let product of selectedProducts" type="hidden" name="productquantities[]" id="productquantity" [value]="product.quantity" />
                    <input *ngFor="let product of selectedProducts" type="hidden" name="productprices[]" id="productprice" [value]="product.price" />
    
                    <button pButton type="button" class="AcceptUI p-button-primary" style="width: 20rem; display: table-cell;" data-billingAddressOptions='{"show":true, "required":false}'
                        [attr.data-apiLoginID]="acceptUiApiLoginId"
                        [attr.data-clientKey]="acceptUiClientKey"
                        data-acceptUIFormBtnTxt="Submit" data-acceptUIFormHeaderTxt="Card Information"
                        data-responseHandler="responseHandler">
                        Buy Now
                    </button>
                </form>
            </div>
        </p-card>
    </div>
</div>


